import { Link } from 'react-router-dom'
import AppBar from '@/components/AppBar'

export default function NotFound() {
  return (
    <>
      <AppBar title="Not found" />
      <main>
        <div className="welcome">
          <div className="logo-mark">?</div>
          <h2>Page not found</h2>
          <p>That link doesn't lead anywhere here.</p>
        </div>
        <Link className="btn btn-primary" to="/" style={{ textDecoration: 'none' }}>Back to home</Link>
      </main>
    </>
  )
}
